import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import CrossArrow from '../../../svg/CrossArrow';
import { setFocusCustom } from '../../../store/focuspage/focuspageSlice';
import Delete from '../../../svg/Delete';
import { deleteFocusCustomThunk } from '../../../store/focuspage/focuspageThunk';
import { setDeleteAlert } from '../../../store/alert/alertSlice';
import EditIcon from '../../../svg/EditSvg';

export default function CustomRedirectCard({ txt, link, item, isDelete }) {
    const token = localStorage.getItem('dizeeToken');
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleClick = () => {
        dispatch(setFocusCustom(item));
        navigate(link);
    };

    return (
        <div className='p-4 py-6 flex w-full justify-between items-center'>
            <div className='flex items-center'>
                <span className='text-white'>{txt}</span>
            </div>
            <div className="flex flex-row items-center gap-x-[15px]">
                <button onClick={handleClick}>
                    <CrossArrow className='h-[14px] w-[14px] cursor-pointer' />
                </button>
                <button onClick={() => {
                    // dispatch(setWholeFocusEvent(item))
                    // navigate(link)
                }} >
                    <EditIcon className='h-[14px] w-[14px]  cursor-pointer' />
                </button>
                {
                    isDelete &&
                    <button onClick={() => {
                        dispatch(setDeleteAlert({
                            type: 'custom',
                            data: {
                                token, payload: {
                                    ...item
                                }
                            }
                        }));
                    }} >
                        {/* <CrossArrow className='h-[14px] w-[14px]  cursor-pointer' /> */}
                        <Delete className='h-[14px] w-[14px]  cursor-pointer' />
                    </button>
                }
            </div>

        </div>
    );
} 